import type { VFC } from 'react'

interface AttributePackageSizeSingleValueProps {
  packageInfo: string
}

const AttributePackageSizeSingleValue: VFC<
  AttributePackageSizeSingleValueProps
> = ({ packageInfo }) => {
  return (
    <div className="a-attributePackageSizeWrapper--border u-padding--bottom u-padding--top u-font-weight--bold">
      {packageInfo}
    </div>
  )
}

export default AttributePackageSizeSingleValue
